import { EXPRESS_API } from 'configs/api/expressApi';
import { useMutation, useQueryClient } from 'react-query';
import { quickVideoKeys } from './quickVideoKeys';
import { useToastError } from 'lib/hooks';
import { successToast } from 'lib/components/toasts/success';
import { useTranslation } from 'react-i18next';

interface IPatchEnabledStatusParams {
  quickVideoId: number;
  enabled: number;
}

const patchEnabledStatus = async (params: IPatchEnabledStatusParams) => {
  return (
    await EXPRESS_API.patch(`/quick-videos/${params.quickVideoId}/enabled`, {
      enabled: params.enabled,
    })
  ).data;
};

export const usePatchEnabledStatusMutation = () => {
  const queryClient = useQueryClient();
  const { showError } = useToastError();
  const { t } = useTranslation();
  return useMutation(
    (params: IPatchEnabledStatusParams) => patchEnabledStatus(params),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(quickVideoKeys.all());
        successToast({ title: t('Quick Video enabled status updated.') });
      },
      onError: err => {
        showError(err);
      },
    }
  );
};
